import { gql } from '@apollo/client'
import { print } from 'graphql'

import { accountsClient, placesClient } from '../../../../utils/apollo/api'
import { getProjectId } from '../../../../utils/session/sessionStorage'
import { getSubdomain } from '../../../../utils/helpers/url'
import { getFieldValueByFieldId } from '../../../../containers/dynamic/form/_form/formatRepliesFormData'

export const USER_FIELD_VALUES_QUERY = gql`
  query UserFieldValuesForAutofill($id: ID) {
    user(id: $id, filter: { includeDisabled: true, ignoreSegments: true }) {
      id
      contract {
        fieldValues {
          id
          value
          fieldId
          field {
            id
          }
        }
      }
      fieldValues {
        id
        value
        fieldId
        field {
          id
        }
      }
    }
  }
`

export const PLACE_FIELD_VALUES_QUERY = gql`
  query PlaceFieldValuesForAutofill($id: ID) {
    place(id: $id, filter: { ignoreSegments: true }) {
      id
      fieldValues {
        id
        value
        fieldId
        field {
          id
        }
      }
    }
  }
`

export const mergeUserFieldValues = user =>
  [
    ...(user?.contract?.fieldValues ?? []),
    ...(user?.fieldValues ?? [])
  ]

export const fetchAutofillValue = async (serviceOrder, source, fieldId, options = {}) => {
  if (!serviceOrder || !source || fieldId == null) return undefined

  const { sessionToken: sessionTokenForUser } = options

  if (source === 'user') {
    const userId = serviceOrder.user?.id
    if (!userId) return undefined
    let fieldValues = []
    if (sessionTokenForUser) {
      fieldValues = await fetchUserContractFieldValuesWithToken(sessionTokenForUser, userId)
    } else {
      const { data } = await accountsClient.query({
        query: USER_FIELD_VALUES_QUERY,
        variables: { id: userId },
        fetchPolicy: 'network-only'
      })
      fieldValues = mergeUserFieldValues(data?.user)
    }
    return getFieldValueByFieldId(fieldValues, fieldId)
  }

  if (source === 'place') {
    const placeId = serviceOrder.place?.id
    if (!placeId) return undefined
    const { data } = await placesClient.query({
      query: PLACE_FIELD_VALUES_QUERY,
      variables: { id: placeId },
      fetchPolicy: 'network-only'
    })
    const fieldValues = data?.place?.fieldValues
    return getFieldValueByFieldId(fieldValues, fieldId)
  }

  return undefined
}

const ACCOUNTS_API_URL = `${process.env.REACT_APP_V2_API_URL}/accounts/api`

export const fetchUserContractFieldValuesWithToken = async (sessionToken, userId) => {
  if (!sessionToken || !userId) return []
  try {
    const workspace = getSubdomain()
    const projectId = getProjectId()
    const headers = {
      'Content-Type': 'application/json',
      Authorization: sessionToken,
      ...(workspace ? { workspace } : {}),
      ...(projectId ? { projectId } : {})
    }
    const res = await fetch(ACCOUNTS_API_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        query: print(USER_FIELD_VALUES_QUERY),
        variables: { id: userId }
      })
    })
    const json = await res.json()
    const user = json?.data?.user
    return mergeUserFieldValues(user)
  } catch {
    return []
  }
}
